import { z } from "zod";

export const cancelEventSchema = z
	.object({
		message: z.string().max(1000).optional(),
	})
	.strict();

export type CancelEventPayload = z.infer<typeof cancelEventSchema>;
